import RouteBase from "routes/RouteBase";
import Home from "./Home";

const Root = (props) => <RouteBase {...props} renderRoute={(p) => <Home {...p} />} />;

export default Root;
